import { get, writable } from "svelte/store";
export class SearchControlManager {
    constructor() {
        this.openStore = writable(true);
        this.collapsedStore = writable(false);
        this.selectedResultStore = writable(undefined);
    }
    getOpenStore() {
        return this.openStore;
    }
    onToggleCollapsed() {
        this.collapsedStore.set(!get(this.collapsedStore));
    }
    getCollapsedStore() {
        return this.collapsedStore;
    }
    getSelectedResultStore() {
        return this.selectedResultStore;
    }
}
